<template lang="pug">
Fragment
  .span-full.mt-3
    div.head.d-lg-flex
      .d-flex
        b-icon.no-print.mr-2(icon="file-earmark-text" variant="dark" font-scale="1.5")
        h4.mb-0.title Boletas
    hr.ot-divider
  div.details
    label.input-label Nº Boleta Abono
    span.display-data
      | {{ ov.nro_boleta_abono || '-' }}
  div.details
    label.input-label Nº Boleta Pago Final
    span.display-data
      | {{ ov.nro_boleta_pago || '-' }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OVReceipts',
  computed: {
    ...mapGetters('OTStore', ['ot', 'printNoDisplay']),
    ov() {
      return this.ot && this.ot.datos_ov_asociada ? this.ot.datos_ov_asociada : {}
    },
  },
}
</script>